import React from 'react';
import BoroughFilter from './BoroughFilter';
import {max, histogram, range} from 'd3-array';

const QuestionProbList = ({neighborhoods, interpolators, formatters, changePriceFocus, price_focus, setActiveNeighborhood, top_space, borough_filter, setBoroughFilter, browser_width}) => {

  const bar_height = 202;

  const price_categories = ['Top', 'Middle', 'Bottom'];

  const neighborhoods_prices = neighborhoods.map((neighborhood) => neighborhood.properties.price);
  const samples_max = max(neighborhoods_prices);

  // TODO: bin ranges hacked bc I decided to stop using bin ranges
  const bin_ranges = [
    {
      string: '$0-1M',
      bottom: 0,
      top: 1000000,
      neighborhoods: []
    },
    {
      string: '$1-2M',
      bottom: 1000000,
      top: 2000000,
      neighborhoods: []
    },
    {
      string: '$2-8M+',
      bottom: 2000000,
      top: 8000000,
      neighborhoods: []
    }
  ]

  for (let neighborhood of neighborhoods) {
    if (neighborhood.properties.price < bin_ranges[0].top) {
      bin_ranges[0].neighborhoods.push(neighborhood);
    } else if (neighborhood.properties.price < bin_ranges[1].top) {
      bin_ranges[1].neighborhoods.push(neighborhood);
    } else {
      bin_ranges[2].neighborhoods.push(neighborhood);
    }
  }

  let filtered_neighborhoods = neighborhoods;
  let focus_value_array = bin_ranges.map((bin) => bin.top);
  if (price_focus) {
    let bin_index = focus_value_array.indexOf(price_focus);
    filtered_neighborhoods = bin_ranges[bin_index].neighborhoods;
  }

  const handleNeighborhoodClick = (neighborhood) => {
    setActiveNeighborhood(neighborhood.properties.neighborhood);
  }

  const handlePriceFilterClick = (value) => {
    if (price_focus === value) {
      changePriceFocus(false)
    } else {
      changePriceFocus(value);
    }
  }

  const neighborhood_item = (neighborhood) => {
    return <div
      className="SideListItem h5 hover relative flex pointer"
      onClick={handleNeighborhoodClick.bind(this, neighborhood)}
      style={{
        background: interpolators.money(neighborhood.properties.price/2000000),
      }}
      key={neighborhood.properties.neighborhood}
      >
        <div className="relative small-caps center"
          style={{
            width: '1.5rem',
            color: 'rgba(0,0,0,0.5)',
          }}
        >
          {formatters.borough_abbreviations[neighborhood.properties.borough]}
        </div>
        <div className="space-between flex grow-1">
          <div className=""
            style={{
              paddingLeft: '0.25rem'
            }}
          >
            {neighborhood.properties.neighborhood}
          </div>
          <div className="">
            {formatters.dollarShort(neighborhood.properties.price)}
          </div>
        </div>
    </div>
  }

  let mobile = false;
  if (browser_width < 451) mobile = true;

  return (
    <div className="no-select" style={{paddingTop: bar_height}}>
      <div className="fixed top-left bg-white"
        style={{top: top_space,
          width: mobile ? '100%' : '360px',
          zIndex: '9'}}
      >
        <BoroughFilter
          borough_filter={borough_filter}
          setBoroughFilter={setBoroughFilter}
        />
        <div className="h6 mt1 px2 flex space-between uppercase">
          Filter by Price
          {price_focus ? (
            <div className="pointer blue hover-underline" onClick={handlePriceFilterClick.bind(this, false)}>Clear Filter</div>
          ) : null}
        </div>
        <div className="flex mt1 tnum h5">
          {price_categories.map((name,i) =>
            <div
              key={i}
              style={{
                background: interpolators.money(((bin_ranges[i].top - bin_ranges[i].bottom)/2 + bin_ranges[i].bottom)/2000000)
              }}
              className={"PriceFilterItem relative px2 pointer flex space-between py1 hover col-4 " + (price_focus === bin_ranges[i].top ? 'active' : '')}
              onClick={handlePriceFilterClick.bind(this, bin_ranges[i].top)}
            >
              <div>{bin_ranges[i].string}</div>
              <div className="ProbNumber" style={{color: 'rgba(0,0,0,0.5)'}}>{bin_ranges[i].neighborhoods.length}</div>
            </div>
          )}
        </div>
        <div className="h6 px1 space-between py1 px2 mt1 uppercase flex">
          <div>Neighborhoods</div>
          <div
            style={{color: 'rgba(0,0,0,0.5)'}}
          >{filtered_neighborhoods.length}</div>
        </div>
      </div>
      <div className="fixed left-0"
        style={{
          width: mobile ? '100%' : '360px',
          top: top_space + bar_height,
          height: `calc(100% - ${top_space + bar_height}px`,
          overflowY: 'auto'
        }}
      >
        <div className="tnum">
          {filtered_neighborhoods.map((neighborhood) =>
            neighborhood_item(neighborhood)
          )}
        </div>
      </div>
    </div>
  )
}

export default QuestionProbList;


/** WEBPACK FOOTER **
 ** ./src/components/QuestionProbList.js
 **/